import cn from 'classnames';
import { useTheme } from 'styled-components';

import { IConDefaultType } from '..';
import { EColorMap } from '../constants/colorMap';

export enum SearchIconVariant {
  SEARCH1 = 'search1',
  SEARCH2 = 'search2',
  SMALL = 'small',
}

export interface ISearchIConProps extends IConDefaultType {
  variant?: SearchIconVariant;
  backgroundColor?: string;
}

function SearchIcon({
  color,
  className,
  size = 20,
  rotate,
  flip,
  variant = SearchIconVariant.SEARCH1,
  backgroundColor = 'white',
}: ISearchIConProps) {
  const theme = useTheme();
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === SearchIconVariant.SEARCH1 && (
        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.5776 13.5781C13.903 13.2526 14.4306 13.2526 14.7561 13.5781L18.0894 16.9114C18.4149 17.2368 18.4149 17.7645 18.0894 18.0899C17.764 18.4153 17.2363 18.4153 16.9109 18.0899L13.5776 14.7566C13.2521 14.4311 13.2521 13.9035 13.5776 13.5781Z"
            fill={color || theme.color.icon.icon_2}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.16675 3.33366C5.94509 3.33366 3.33341 5.94533 3.33341 9.16699C3.33341 12.3887 5.94509 15.0003 9.16675 15.0003C12.3884 15.0003 15.0001 12.3887 15.0001 9.16699C15.0001 5.94533 12.3884 3.33366 9.16675 3.33366ZM1.66675 9.16699C1.66675 5.02486 5.02461 1.66699 9.16675 1.66699C13.3089 1.66699 16.6667 5.02486 16.6667 9.16699C16.6667 13.3091 13.3089 16.667 9.16675 16.667C5.02461 16.667 1.66675 13.3091 1.66675 9.16699Z"
            fill={color || theme.color.icon.icon_2}
          />
        </svg>
      )}
      {variant === SearchIconVariant.SEARCH2 && (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.2929 16.2929C16.6834 15.9024 17.3166 15.9024 17.7071 16.2929L21.7071 20.2929C22.0976 20.6834 22.0976 21.3166 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L16.2929 17.7071C15.9024 17.3166 15.9024 16.6834 16.2929 16.2929Z"
            fill={color || EColorMap.gray_0}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18C14.866 18 18 14.866 18 11C18 7.13401 14.866 4 11 4ZM2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 15.9706 15.9706 20 11 20C6.02944 20 2 15.9706 2 11Z"
            fill={color || EColorMap.gray_0}
          />
        </svg>
      )}
      {variant === SearchIconVariant.SMALL && (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="24" height="24" fill={backgroundColor} />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.33333 11.1706C5.33333 7.94629 7.95197 5.33053 11.1847 5.33053C14.4174 5.33053 17.036 7.94629 17.036 11.1706C17.036 14.3948 14.4174 17.0106 11.1847 17.0106C7.95197 17.0106 5.33333 14.3948 5.33333 11.1706ZM11.1847 3.99719C7.21777 3.99719 4 7.20773 4 11.1706C4 15.1334 7.21777 18.3439 11.1847 18.3439C12.9214 18.3439 14.5145 17.7286 15.7568 16.7042L18.8607 19.8026C19.1213 20.0627 19.5434 20.0624 19.8035 19.8018C20.0636 19.5412 20.0632 19.1191 19.8027 18.859L16.7029 15.7646C17.7432 14.5203 18.3693 12.9186 18.3693 11.1706C18.3693 7.20773 15.1516 3.99719 11.1847 3.99719Z"
            fill={color || EColorMap.gray_0}
          />
        </svg>
      )}
    </i>
  );
}

export default SearchIcon;
